import { getTrashResponseSchema, trashNodesResponseSchema } from '@/types/trash';
import { SortOrderOptions, SortOrderValues } from '@/types/sort';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const BASE = `${INTERNAL_V1}/trash`;

// Adding type and undoable here for now to use it in the hook. A better solution would be good
export const trashNodesQuery = async (
  params: { nodes: Array<string>; type?: string; undoable?: boolean },
  token?: string,
) => {
  const response = await damRequest('POST', BASE, token, {
    body: params,
  });
  return trashNodesResponseSchema.parse(response);
};

// Adding type and undoable here for now to use it in the hook. A better solution would be good
export const restoreNodesQuery = async (
  params: { nodes: Array<string>; type?: string; undoable?: boolean },
  token?: string,
) => {
  const response = await damRequest('POST', `${BASE}/restore`, token, {
    body: params,
  });
  return trashNodesResponseSchema.parse(response);
};

export const getTrashQuery = async (
  params: {
    pagination: { limit: number | null; offset: number | null };
    sort: { order: string; value: string };
  },
  token?: string,
) => {
  const response = await damRequest(
    'GET',
    `${BASE}?offset=${params.pagination?.offset ?? ''}&limit=${params.pagination?.limit ?? ''}&sortBy=${
      params?.sort?.value ?? SortOrderValues.CREATED_AT
    }&sortOrder=${params?.sort?.order ?? SortOrderOptions.ASC}`,
    token,
  );
  return getTrashResponseSchema.parse(response);
};

export const emptyTrashQuery = async (params: void, token?: string) => {
  const response = await damRequest('DELETE', BASE, token);
  return trashNodesResponseSchema.parse(response);
};
